import * as React from 'react'
import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'
import { string } from 'yup'
import Button from 'web-makeup/dist/Button'
import Input from 'web-makeup/dist/Input'
import Component from '@reactions/component'
import { colors } from 'web-makeup/dist/design-system/config/data/theme'
import CloudinaryImage from 'web-makeup/dist/CloudinaryImage'

import { InputErrorMessage } from '../InputErrorMessage'
import { GetQuoteForm } from '../../typings/types'
import VideoThumbnail from '../VideoThumbnail'
import EnvironmentContext from '../EnvironmentContext'
import { placeholderColor } from '../../style'

const { Search } = Input
const SearchField = styled(Search)`
  ${(p: { color?: string | undefined }) => {
    let style = ''
    if (p.color) {
      style = `.ant-btn-primary,
               .ant-btn-primary:hover {
                  border-color: ${p.color};
                  background: ${p.color};
                }
                
                `
    }
    return style
  }};
  .ant-input,
  .ant-input:hover,
  .ant-input:focus {
    border: 1px solid ${colors.radagast};
    height: 2.75rem;
    font-size: 1rem;
    color: ${colors.black1};

    ${placeholderColor(colors.nebula)};
  }
  .ant-btn-primary.ant-btn-primary.ant-btn-primary,
  .ant-btn-primary:hover {
    background: ${colors.black1};
    border-color: ${colors.black1};
    height: 2rem;
    padding: 0 1rem;
    color: white;
    border-radius: 6.25rem;
    margin-right: 0.5rem;
  }

  /* stylelint-disable */

  &&& {
    .ant-input.ant-input.ant-input {
      border-color: ${colors.radagast};
      box-shadow: none;
    }

    .ant-input.ant-input.ant-input:focus {
      border-color: ${colors.black1};
      box-shadow: none;
    }
  }

  /* stylelint-enable */
`

const InspirationList = styled.ul`
  margin-top: 0.5rem;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-right: -0.25rem;
  margin-left: -0.25rem;

  > li {
    flex-basis: 100%;
    padding: 0.75rem 0;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 17rem;
    margin: 0 auto;

    > a {
      border-radius: 12px;
      display: inline-flex;
    }

    @media (min-width: 36rem) {
      flex-basis: 50%;
      padding: 0.5rem 0.25rem;
      margin: 0;
    }

    @media (min-width: 48rem) {
      flex-basis: 33%;
      padding: 0.5rem 0.25rem;
      margin: 0;
    }
  }
`

export const DeleteButton: any = styled(Button as any)`
  margin-top: 0.25rem;
  &&,
  &&:hover,
  &&:active {
    border: none;
    height: auto;
    padding: 0;
    position: absolute;
    background: 0;
    filter: drop-shadow(0 4px 4px rgba(0, 0, 0, 0.25));
    right: 0.5rem;
    top: 1rem;
  }

  img {
    width: 1.5rem;
  }
`

const InspirationLink = styled.a`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  iframe {
    background: url(https://res.cloudinary.com/ninety-seconds/image/upload/v1629709034/-design-system/placeholder-generic-no-preview.svg)
      no-repeat center;
    background-size: cover;
  }
`

const handleSearch = (setState, handleAdd) => value => {
  const validator = string()
    .url('INVALID_URL')
    .required('REQUIRED_URL')

  try {
    validator.validateSync(value)
    setState({ error: undefined, value: '' })

    if (handleAdd) {
      handleAdd(value)
      if (window.analytics) {
        window.analytics.track('Shoot Inspiration Video Added', {
          video_url: value,
        })
      }
    }
  } catch (e) {
    setState({ error: e.message })
  }
}

interface OwnProps {
  onAdd?: (value: string) => void
  onRemove?: (index: number) => void
  values?: GetQuoteForm.Quote['inspirationVideoUrls'] | null
  loading: boolean
  title?: React.ReactNode | null
  description?: React.ReactNode | null
  color?: string | undefined
  summaryOnly?: boolean | null
}

const PurchaseShootInspiration: React.SFC<OwnProps> = ({
  onAdd,
  onRemove,
  loading,
  values,
  title,
  description,
  color,
  summaryOnly,
}) => (
  <>
    {!summaryOnly && (
      <Component initialState={{ error: undefined, value: '' }}>
        {({ state, setState }) => (
          <>
            <SearchField
              disabled={loading}
              placeholder="Add URL"
              value={state.value}
              color={color}
              enterButton={<FormattedMessage id="purchase.shoot.inspirations.add" />}
              onChange={event => setState({ value: event.currentTarget.value })}
              onSearch={handleSearch(setState, onAdd)}
              onKeyDown={(event: React.KeyboardEvent<HTMLElement>) => {
                const ENTER_KEY = 13
                if (event.keyCode === ENTER_KEY) {
                  event.preventDefault()
                }
              }}
            />
            {state.error && (
              <InputErrorMessage>
                <FormattedMessage id={`purchase.shoot.inspirations.error.${state.error}`} />
              </InputErrorMessage>
            )}
          </>
        )}
      </Component>
    )}

    <InspirationList>
      {values &&
        values.length > 0 &&
        values.map((inspiration, index) => (
          <li key={index}>
            <InspirationLink href={inspiration}>
              <EnvironmentContext.Consumer>
                {({ CLOUDINARY_DOWNLOAD_URL }) => (
                  <VideoThumbnail
                    url={inspiration}
                    CLOUDINARY_DOWNLOAD_URL={CLOUDINARY_DOWNLOAD_URL}
                  />
                )}
              </EnvironmentContext.Consumer>
            </InspirationLink>
            {onRemove && (
              <DeleteButton onClick={() => onRemove(index)}>
                <CloudinaryImage
                  useSourceFormat
                  source={{
                    type: 'upload',
                    id: 'v1592895570/marketing/-surge-campaign/icon-close.png',
                  }}
                />
              </DeleteButton>
            )}
          </li>
        ))}
    </InspirationList>
  </>
)

export default PurchaseShootInspiration



// WEBPACK FOOTER //
// ./src/components/PurchaseShootInspiration/PurchaseShootInspiration.tsx